import { createReactBlockSpec } from "@blocknote/react";
import { InlineImage } from "../../components/InlineImage";
import { TwoImagesBlock } from "./TwoImagesBlock";

export const TwoImagesBlockSpec = createReactBlockSpec(
  {
    type: "twoImagesBlock",
    propSchema: {
      leftImage: {
        default: "",
      },

      rightImage: {
        default: "",
      },

      leftAlt: {
        default: "",
      },

      rightAlt: {
        default: "",
      },

      leftUrl: {
        default: "",
      },

      rightUrl: {
        default: "",
      },

      leftCaption: {
        default: "",
      },

      rightCaption: {
        default: "",
      },

      widthPercentage: {
        default: 50,
      },
    },
    content: "none",
    isSelectable: true,
  },
  {
    render: ({
      editor,
      block: {
        id,
        props: {
          leftImage,
          rightImage,
          leftAlt,
          rightAlt,
          leftUrl,
          rightUrl,
          leftCaption,
          rightCaption,
          widthPercentage,
        },
      },
    }) => {
      const updateBlock = (
        newProps: Partial<{
          leftImage: string;
          rightImage: string;
          leftAlt: string;
          rightAlt: string;
          leftUrl: string;
          rightUrl: string;
          leftCaption: string;
          rightCaption: string;
          widthPercentage: number;
        }>,
      ) => {
        // biome-ignore lint/suspicious/noExplicitAny:
        editor.updateBlock(id, { props: newProps as any });
      };

      return (
        <TwoImagesBlock
          leftImage={leftImage}
          rightImage={rightImage}
          leftAlt={leftAlt}
          rightAlt={rightAlt}
          leftUrl={leftUrl}
          rightUrl={rightUrl}
          leftCaption={leftCaption}
          rightCaption={rightCaption}
          widthPercentage={widthPercentage}
          updateBlock={updateBlock}
        />
      );
    },
    toExternalHTML: ({
      block: {
        props: {
          leftImage,
          rightImage,
          leftAlt,
          rightAlt,
          leftUrl,
          rightUrl,
          leftCaption,
          rightCaption,
          widthPercentage,
        },
      },
    }) => {
      return (
        <div>
          <div
            style={{
              display: "inline-block",
              verticalAlign: "top",
              marginRight: "2%",
              width: `${widthPercentage - 1}%`,
            }}
          >
            <InlineImage image={leftImage} alt={leftAlt} caption={leftCaption} url={leftUrl} />
          </div>
          <div style={{ display: "inline-block", width: `${99 - widthPercentage}%` }}>
            <InlineImage image={rightImage} alt={rightAlt} caption={rightCaption} url={rightUrl} />
          </div>
        </div>
      );
    },
  },
);
